// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5485":"f2da3c61","7502":"3b53517f"}[chunkId] + ".chunk.css";
};